import { useState } from "react";

export function CompanyLogo({ name, logoUrl, size = "sm" }) {
  const [imgError, setImgError] = useState(false);
  
  const sizes = {
    sm: { container: "w-7 h-7", text: "text-xs" },
    md: { container: "w-9 h-9", text: "text-sm" },
  };
  const s = sizes[size] || sizes.sm;
  const initial = (name || "?").charAt(0).toUpperCase();
  const showImage = logoUrl && !imgError;

  return (
    <div
      className={`${s.container} rounded-lg flex items-center justify-center flex-shrink-0 overflow-hidden ${
        showImage ? "bg-white" : "bg-primary/15 border border-primary/20"
      }`}
      data-testid="company-logo"
    >
      {showImage ? (
        <img
          src={logoUrl}
          alt={`${name} logo`}
          className="w-full h-full object-contain p-0.5"
          onError={() => setImgError(true)}
        />
      ) : (
        <span className={`${s.text} font-bold text-primary`}>{initial}</span>
      )}
    </div>
  );
}
